export const site_address = "https://www.nathan-beals.com";
//export const site_address = "https://localhost";
export const site_tags_address = "https://www.nathan-beals.com/api/tags?";
//export const site_tags_address = "https://localhost/api/tags?"; // Used for local server testing.